import { render, staticRenderFns } from "./RischioSpecificoDialog.vue?vue&type=template&id=16af5990"
import script from "./RischioSpecificoDialog.vue?vue&type=script&lang=js"
export * from "./RischioSpecificoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports